import React, { useEffect, useState } from 'react'
import EventsListingCard from './EventsListingCard'
import cardImage1 from "../event-view-all-page/image/event-image-1.png"
import cardImage2 from "../event-view-all-page/image/event-image-2.png"
import cardImage3 from "../event-view-all-page/image/event-image-3.png"
import cardImage4 from "../event-view-all-page/image/event-image-4.png"
import hero from "../event-view-all-page/image/hero-img.jpg"

import { FaLocationDot } from "react-icons/fa6";
import './EvenetListingPage.css'
import '../My--Bidding--design/PartyPackageListingPage.css';


import axios from 'axios';
import { Link } from 'react-router-dom'
import EventsListingCardSkeleton from './EventsListingCardSkeleton'
import FilterModal from '../My--Bidding--design/FilterModel'
import FilterBar from '../My--Bidding--design/FilterBar'


const url = "https://partywitty.com/master/assets/uploads/";

const filters = [
    {
        "label": "Filter",
        "type": "button",
        "icon": "PiSlidersHorizontalBold"
    },
    {
        "label": "Sort By",
        "type": "dropdown",
        "group": "sort",
        "icon": "IoIosArrowDown",
        "options": ["A to Z", "Z to A",]
    },

    {
        "label": "Review",
        "type": "dropdown",
        "icon": "IoIosArrowDown",
        "options": ["1 stars", "2 stars", "3 stars", "4 stars", "5 stars"]
    },
    {
        "label": "My Favorite",
        "type": "pill",
        "icon": "FaHeart"
    },
    {
        "label": "Friends Favorite",
        "type": "pill",
        "icon": "FaUsers"
    },
    {
        "label": "Under 999",
        "type": "pill",
        "icon": "FaRupeeSign"
    },
    {
        "label": "Previously Booked",
        "type": "pill",
        "icon": "FaHistory"
    },
    {
        "label": "New to You",
        "type": "pill",
        "icon": "FaStar"
    }
]



export default function EvenetListingPage() {

    const [eventsData, setEventData] = useState([]);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);

    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0];

    const fetchUpcomingEvents = async (lat, lng, date) => {
        try {
            const formData = new FormData();
            formData.append('latitude', lat);
            formData.append('longitude', lng);
            formData.append('date', date);

            const response = await axios.post(
                'https://partywitty.com/master/APIs/ClubEvent/upcomingEvents',
                formData
            );

            if (response.data.status === true) {
                setEventData(response.data.data);
                console.log('Upcoming Events:', response.data.data);
            } else {
                console.warn('No events found:', response.data.msg);
                setEventData([]); // Clear if no events
            }
        } catch (error) {
            console.error('Error fetching upcoming events:', error);
            setEventData([]);
        }
    };

    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const latStr = latitude.toString();
                    const lngStr = longitude.toString();

                    setLatitude(latStr);
                    setLongitude(lngStr);

                    fetchUpcomingEvents(latStr, lngStr, today);
                },
                (error) => {
                    alert('Please enable Geo Location Service to find events in your locality.');
                    console.error('Error in finding location:', error);
                }
            );
        } else {
            console.error('Geolocation is not available in this browser.');
        }
    }, []);


    const eventUrl = (e) => {
        return `/${(e.cityName?.replace(/ /g, "-") || "").toLowerCase()}/${(e.areaName?.replace(/ /g, "-") || "").toLowerCase()}/${(e.clubName?.trim().split(/ +/).join("-").replace(/ /g, "-") || "").toLowerCase()}/event/${(e.name?.trim().split(/ +/).join("-").replace(/ /g, "-") || "").toLowerCase()}`;
    };

    function generateClubUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "_").toLowerCase() : "");

        return `/event/${format(clubName)}-${format(cityName)}-${format(areaName)}-${format(title)}`;
    }

    const [filtersAndSort, setFiltersAndSort] = useState({});

    const [showFilter, setShowFilter] = useState(false);



      const fetchDataWithFilters = () => {
        // const venueIds = filtersAndSort?.venue || [];
        // const packageIds = filtersAndSort?.package || [];
        // not it use for now 
    };

    const filteredData = eventsData.filter((item) => {
        if (filtersAndSort.selectedDropdowns?.Review) {
            const selectedReview = parseInt(filtersAndSort.selectedDropdowns.Review[0]);
            const itemRating = parseFloat(item.totalAverageRating);

            const lowerBound = selectedReview - 0.4;
            const upperBound = selectedReview + 0.5;

            if (isNaN(itemRating) || itemRating < lowerBound || itemRating >= upperBound) {
                return false;
            }
        }


        // if (filtersAndSort.selectedPills.includes("Friends Favorite") && !item.isFriendFavorite) {
        //     return false;
        // }

        // if (filtersAndSort.selectedPills.includes("Under 999") && item.price >= 999) {
        //     return false;
        // }

        return true;
    }).sort((a, b) => {
        const sortType = filtersAndSort.selectedDropdowns?.["Sort By"];
        if (sortType === "A to Z") return a.name.localeCompare(b.name);
        if (sortType === "Z to A") return b.name.localeCompare(a.name);
        return 0;
    });




    return (
        <>
            <div className='eventlist-container'>
                <div className="eventlist-hero-section">
                    <div className="eventlist-hero-image-wrapper">
                        <img src={hero} alt="Event Banner" className="eventlist-hero-image" />
                        <div className="eventlist-hero-text-overlay">
                            <div className="eventlist-hero-text">
                                <h1>Event Happening Today</h1>
                            </div>
                        </div>
                    </div>
                </div>


                <div className='party-package-page-filter-container'>
                    <div className='party-package-page-filter'>
                        <div className='party-package-page-filter-title-box'>

                            <div className='pppftb-filter'>
                                <FilterBar filterList={filters} setFiltersAndSort={setFiltersAndSort} setShowFilter={setShowFilter} />
                            </div>
                        </div>

                    </div>
                </div>

                <div className="event-cards-page-container">
                    {eventsData.length === 0 ?
                        <>
                            {Array.from({ length: 6 }).map((_, index) => (
                                <EventsListingCardSkeleton key={index} />
                            ))}

                        </>
                        : (
                            filteredData.map((event, index) => (
                                <Link to={generateClubUrl(event.clubName, event.cityName, event.areaName, event.name)} key={index} >
                                    <EventsListingCard title={event.name} date={event.event_date} time={event.event_time} rating={event.rating} location={event.cityName} distance={event.distance} type={event.categoryName} price={event.min_price} image={url + event.image} offer={event.offer} />
                                </Link>
                            )))}
                </div>
            </div>
              <FilterModal isOpen={showFilter} onClose={() => setShowFilter(false)} setFiltersAndSort={setFiltersAndSort} fetchDataWithFilters={fetchDataWithFilters} />
        </>
    )
}
